import { render, staticRenderFns } from "./PanelPoints.vue?vue&type=template&id=7facde71"
import script from "./PanelPoints.vue?vue&type=script&lang=js"
export * from "./PanelPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports